/**
 * @info
 *
 * *The "store/global" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind global functionality.
 *
 * *This file*
 * This file outlines "mutations". Mutations are intended
 * to be as simple as possible. All modifications to the state
 * object should happen inside a mutation function. Each
 * of these functions must be synchronous. There should be nothing
 * that has a time delay, such as an AJAX request or a setTimeout.
 */
export default {
  refreshCart (state, data) {
    if (data.errors) {
      state.cart.errors = data.errors
    } else {
      state.cart = data
    }
  },
  openModal (state, data) {
    state.modal.current = data
  },
  toggleSearch (state) {
    state.searchOpened = !state.searchOpened
  },
  closeSearch (state) {
    state.searchOpened = false
  },
  setDefaultAddress (state, id) {
    state.defaultAddressId = id
  }
}
